import { Address } from './address';
import { Phone } from './phone';
import { Email } from './email';
import { Creci } from './creci';
import { Document } from './document';
import { Comparable } from '../utils/comparable';

export class Person implements Comparable<Person> {
    public static readonly INDIVIDUAL = '1';
    public static readonly COMPANY = '2';

    constructor(
        public id: number = 0,
        public type: string = Person.INDIVIDUAL,
        public person_name: string = '',
        public company_name: string = '',
        public friendly_name: string = '',
        public person_friendly_name: string = '',
        public birthday: Date|any = null,
        public email: Email = new Email(),
        public document: Document = new Document(),
        public site: string = '',
        public instagram: string = '',
        public facebook: string = '',
        public tiktok: string = '',
        public youtube: string = '',
        public twitter: string = '',
        public linkedin: string = '',
        public phone: Phone = new Phone(),
        public cellphone: Phone = new Phone(),
        public creci: Creci = new Creci(),
        public perfil_id: string = '',
        public brand: string = '',
        public about: string = '',
        public address: Address|any = new Address(),
        public files: any = [],
        public status: number = 0,
        public verification: any = {},
        public username: string = '',
        public deny_requesting: any = null,
        public visibility_score: any = 0,
        public allow_authorization_requests: any = 1,
        public allow_material_requests: any = 1,
        public allow_training_requests: any = 1,
        public allow_proposal_requests: any = 1

    ) { }

    isIndividual(): boolean {
        return this.type == Person.INDIVIDUAL;
    }

    compareTo(other: Person): number {
        if (this.id = other.id) {
            return 0;
        } else if (this.id > other.id) {
            return 1;
        }
        return -1;
    }
}
